import type { SelectionScopeDto } from '@dealstack/shared/lib/backendClient';
import type { TransactionListQuery } from '@dealstack/frontend/app/services/dealstackAi/dealstackAi.types';

const SCOPE_KEYS = [
	'issuerId',
	'securityId',
	'personId',
	'currencyId',
	'documentId',
	'documentSummaryKey',
	'quickFilter',
	'reasonCode',
	'search',
] as const satisfies ReadonlyArray<keyof SelectionScopeDto>;

/** The selection scope of a list query: its filter, without sort or paging. */
export const selectionScopeOf = (query: TransactionListQuery): SelectionScopeDto => {
	const scope: SelectionScopeDto = {};
	for (const key of SCOPE_KEYS) {
		const value = query[key];
		if (value !== undefined && value !== '') {
			Object.assign(scope, { [key]: value });
		}
	}
	return scope;
};

export const sameSelectionScope = (a: SelectionScopeDto, b: SelectionScopeDto): boolean =>
	SCOPE_KEYS.every((key) => (a[key] ?? '') === (b[key] ?? ''));
